<div class="editor-wrapper" *ngIf="editor">

    <!-- TOOLBAR -->
    <div class="toolbar">

        <button type="button" bTooltip title="Grassetto" data-bs-container="body" (click)="editor.chain().focus().toggleBold().run()"
            [class.active]="editor.isActive('bold')">
            <i class="fa-solid fa-bold"></i>
        </button>

        <button type="button" bTooltip title="Corsivo" data-bs-container="body" (click)="editor.chain().focus().toggleItalic().run()"
            [class.active]="editor.isActive('italic')">
            <i class="fa-solid fa-italic"></i>
        </button>

        <button type="button" bTooltip title="Barrato" data-bs-container="body" (click)="editor.chain().focus().toggleStrike().run()"
            [class.active]="editor.isActive('strike')">
            <i class="fa-solid fa-strikethrough"></i>
        </button>
        <button type="button" bTooltip title="Sottolineato" data-bs-container="body" (click)="editor.chain().focus().toggleUnderline().run()"
            [class.active]="editor.isActive('underline')">
            <i class="fa-solid fa-underline"></i>
        </button>
        <button type="button" bTooltip title="Elenco puntato" data-bs-container="body" (click)="editor.chain().focus().toggleBulletList().run()">
            <i class="fa-solid fa-list-ul"></i>
        </button>

        <button type="button" bTooltip title="Elenco numerato" data-bs-container="body" (click)="editor.chain().focus().toggleOrderedList().run()">
            <i class="fa-solid fa-list-ol"></i>
        </button>
        <button type="button" bTooltip title="Paragrafo" data-bs-container="body" (click)="editor.chain().focus().setParagraph().run()">
            <i class="fa-solid fa-paragraph"></i>
        </button>

        <button type="button" bTooltip title="Titolo 1" data-bs-container="body" (click)="editor.chain().focus().toggleHeading({ level: 1 }).run()">
            <i class="fa-solid fa-heading"></i>1
        </button>

        <button type="button" bTooltip title="Titolo 2" data-bs-container="body" (click)="editor.chain().focus().toggleHeading({ level: 2 }).run()">
            <i class="fa-solid fa-heading"></i>2
        </button>
        <button type="button" bTooltip title="Allinea a sinistra" data-bs-container="body" (click)="editor.chain().focus().setTextAlign('left').run()">
            <i class="fa-solid fa-align-left"></i>
        </button>

        <button type="button" bTooltip title="Centra" data-bs-container="body" (click)="editor.chain().focus().setTextAlign('center').run()">
            <i class="fa-solid fa-align-center"></i>
        </button>

        <button type="button" bTooltip title="Allinea a destra" data-bs-container="body" (click)="editor.chain().focus().setTextAlign('right').run()">
            <i class="fa-solid fa-align-right"></i>
        </button>

        <button type="button" bTooltip title="Giustifica" data-bs-container="body" (click)="editor.chain().focus().setTextAlign('justify').run()">
            <i class="fa-solid fa-align-justify"></i>
        </button>
        <button type="button" bTooltip title="Inserisci tabella" data-bs-container="body" (click)="editor.chain().focus().insertTable({ rows: 1, cols: 1, withHeaderRow: true }).run()">
            <i class="fa-solid fa-table"></i>
        </button>

        <button type="button" bTooltip title="Bordi tabella: attiva/disattiva" data-bs-container="body"
            (click)="toggleTableBorders()">
            <i class="fa-solid fa-border-all"></i>
        </button>

        <select #layoutSelect title="Inserisci tabella a colonne predefinite" (change)="insertLayoutTable(layoutSelect)">
            <option value="">Colonne</option>
            @for (layout of tableLayouts; track layout.value) {
            <option [value]="layout.value">{{layout.label}}</option>
            }
        </select>

        <select #verticalAlignSelect title="Orientamento delle celle delle righe selezionate"
            (change)="setRowVerticalAlign(verticalAlignSelect)">
            <option value="">Orientamento celle</option>
            <option value="top">In alto</option>
            <option value="middle">Al centro</option>
            <option value="bottom">In basso</option>
        </select>

        <button type="button" bTooltip title="Aggiungi riga sotto" data-bs-container="body" (click)="addRowAfter()">
            <i class="fa-solid fa-table-cells-large"></i> +
        </button>

        <button type="button" bTooltip title="Aggiungi colonna a destra" data-bs-container="body" (click)="addColumnAfter()">
            <i class="fa-solid fa-table-columns"></i> +
        </button>

        <button type="button" bTooltip title="Elimina riga" data-bs-container="body" (click)="deleteRow()">
            <i class="fa-solid fa-trash"></i> Riga
        </button>

        <button type="button" bTooltip title="Elimina colonna" data-bs-container="body" (click)="deleteColumn()">
            <i class="fa-solid fa-trash"></i> Col.
        </button>

        <button type="button" bTooltip title="Elimina tabella" data-bs-container="body" (click)="editor.chain().focus().deleteTable().run()">
            <i class="fa-solid fa-table-cells"></i> x
        </button>
        <select title="Tipo di carattere" (change)="setFontFamily($any($event.target).value)">
            <option value="Arial">Arial</option>
            <option value="Georgia">Georgia</option>
            <option value="Times New Roman">Times</option>
            <option value="Courier New">Courier</option>
        </select>

        <select title="Dimensione carattere" (change)="setFontSize($any($event.target).value)">
            <option value="8px">A--</option>
            <option value="10px">A-</option>
            <option value="12px" selected>A</option>
            <option value="14px">A+</option>
            <option value="18px">AA</option>
            <option value="24px">AAA</option>
        </select>
        <input type="color" title="Colore testo" (input)="setColor($any($event.target).value)" />
        <button type="button" bTooltip title="Rimuovi colore testo" data-bs-container="body" (click)="clearColor()">
            <i class="fa-solid fa-font"></i>
        </button>
        <input type="color" title="Colore di sfondo del testo" value="#ffff00" (input)="setBackgroundColor($any($event.target).value)" />
        <button type="button" bTooltip title="Rimuovi colore di sfondo" data-bs-container="body" (click)="clearBackgroundColor()">
            <i class="fa-solid fa-eraser"></i>
        </button>
        <button type="button" bTooltip title="Inserisci immagine" data-bs-container="body" (click)="fileInput.click()">
            <i class="fa-solid fa-image"></i>
        </button>
        <button type="button" bTooltip title="Inserisci blocco condizionale (SE)" data-bs-container="body" (click)="insertIfBlock()">
            <i class="fa-solid fa-code-branch"></i>
        </button>

        <button type="button" bTooltip title="Inserisci condizione SE in linea (sul testo selezionato)" data-bs-container="body" (click)="insertIfInline()">
            <i class="fa-solid fa-code-merge"></i>
        </button>

        <button type="button" bTooltip title="Rimuovi blocco condizionale (mantiene il contenuto)"
            data-bs-container="body" (click)="removeIfBlock()">
            <i class="fa-solid fa-square-minus"></i>
        </button>

        <button type="button" bTooltip title="Mostra/nascondi HTML prodotto" data-bs-container="body"
            [class.active]="showHtml" (click)="toggleHtml()">
            <i class="fa-solid fa-code"></i>
        </button>

        <select #variableSelect title="Inserisci variabile" (change)="insertVariable(variableSelect)">
            <option value="">Variabili</option>
            @for (variable of variableList; track variable.id) {
            <option [value]="variable.id">{{variable.name}}</option>
            }
        </select>


    </div>

    @if (imageError) {
    <div class="image-error">{{imageError}}</div>
    }

    <!-- EDITOR -->

    <tiptap-editor [editor]="editor" [style.min-height]="minHeight">
    </tiptap-editor>

    @if (showHtml) {
    <div class="html-output">
        <div class="html-output-header">
            <span>HTML prodotto</span>
            <button type="button" (click)="copyHtml()">Copia</button>
        </div>
        <textarea readonly rows="10" [value]="htmlOutput"></textarea>
    </div>
    }



</div>
<div class="required-msg">Campo obbligatorio</div>
<input #fileInput type="file" accept="image/*" hidden (change)="onFileSelected($event)" />